import React from "react";
import { Link } from "react-router-dom";
import { Flex } from "@components";
import {
  Button,
  DatePicker,
  Progress,
  Popconfirm,
  Table,
  Input,
  Icon,
  Select,
  Upload,
  message,
  Spin,
  Radio,
  Row,
  Col
} from "antd";
import SiderMenu from "@pages/Assembly/siderMenu";
import {NHConfirm} from "@components/common/NHModal";
import Breadcrumb from "@pages/Assembly/Breadcrumb";
import TitleTop from "@pages/Assembly/titleTop";
import NHFetch from "@utils/NHFetch";
import { getLoginUser } from "@utils/NHCore";
import "./index.css";
import createHistory from "history/createHashHistory";
import CommonTip from "../common";
import NextButton from "@pages/SelfHelp/common/nextIndex";
import { mkbz } from "@pages/Assembly/siderMenu/menuObj";
import Hint from "@pages/SelfHelp/common/hint";
const history = createHistory();
const RadioGroup = Radio.Group;

export default class UpdateInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mkbz: "GD005_11",
      hjmc: "",
      nextUrl: "", //左侧菜单加载完后传进来
      search: "",
      menuList: [],
      uploading: false,
      lbnrList:[],
      radioValue:'',
      operable: true,                 //是否显示环节
    };
  }

  componentWillMount(){
    this.queryQztjAndYlhj((operable)=>{
      if (operable) {
        this.getHint();
      }
    })
  }

  getHint=()=>{
    NHFetch("api/zhxg-yxwz/whrj/lstdghlb/getLbNr", 'get')
        .then(res => {
            if (res && res.data) {
                this.setState({
                    lbnrList : res.data.lbnrList,
                    radioValue: res.data.radioValue 
                });
            }
        });
  }

  //查询前置条件和依赖环节
  queryQztjAndYlhj = (callback) => {
    let xsid = getLoginUser() ? getLoginUser().userId : '';
    if (!xsid) {
        this.setState({
            nonOperationalData: { nologin: true },
            operable: false,
        });
        return;
    }
    let zzbdhjid = this.getUrlParams('pkid');
    NHFetch("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid })
        .then(res => {
            if (res && res.data) {
                let kfsj = res.data['kfsj'];
                let ylhj = res.data['ylhj'];
                let qzhj = res.data['qzhj'];
                this.setState({ nonOperationalData: res.data });
                if (kfsj && kfsj['YXSJ'] != '1') {
                    this.setState({ operable: false });
                }

                if (ylhj && ylhj.length > 0) {
                    this.setState({ operable: false });
                }

                if (qzhj && qzhj.length > 0) {
                    this.setState({ operable: false });
                }

                if (callback) {
                    callback(this.state.operable);
                }
            }
        });
  };

  //获取url中传递的参数
  getUrlParams = (param) => {
    return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
  };
  

  setMenuList = (menuList) => {
    let nextCount = 0;
    let bz = this.state.mkbz;
    menuList.map((elem, index) => {
      if (elem.HJDM == bz) {
        let hjmc = elem.HJMC;
        this.setState({ hjmc: hjmc });
        nextCount = index + 1;
        return;
      }
    });
    let menu = menuList[nextCount];
    if (menu) {
      let hjdm = menu.HJDM;
      if (hjdm.indexOf("GD") == 0) {
        let gdUrl = mkbz[hjdm];
        this.setState({
          nextUrl: gdUrl,
          search: "pkid=" + menu.PKID,
        });
      } else if (hjdm.indexOf("ZDY") == 0) {
        let zdyUrl = "/customLink";
        this.setState({
          nextUrl: zdyUrl,
          search: "pkid=" + menu.PKID + "&mkbz=" + hjdm + "&lx=" + menu.LX,
        });
      }
    } else {
      this.setState({
        nextUrl: "",
        search: "",
      });
    }
  };

  onChange = (e) => {
    NHConfirm({
      content: "确定？", type: "danger", onOk: () => {
        this.setState({
          uploading: true
        })
        let zzbdhjid = this.getUrlParams('pkid');
        NHFetch(`api/zhxg-yxwz/whrj/lstdghlb/updateGhlbmd`, 'get', {'lbid': e.target.value, 'zzbdhjid': zzbdhjid})
        .then(res => {
            if (res && res.data == 1) {
              message.success("选择成功！");
              this.setState({
                radioValue: e.target.value,
                uploading: false
              })
            } else {
              message.error("确定后不能再更改");
              this.setState({
                uploading: false
              })
            }
        });
      }
  });

    // this.setState({
    //   uploading: true
    // })
    // let zzbdhjid = this.getUrlParams('pkid');
    // NHFetch(`api/zhxg-yxwz/whrj/lstdghlb/updateGhlbmd`, 'get', {'lbid': e.target.value, 'zzbdhjid': zzbdhjid})
    // .then(res => {
    //     if (res && res.data == 1) {
    //       message.success("更换成功！");
    //       this.setState({
    //         radioValue: e.target.value,
    //         uploading: false
    //       })
    //     } else {
    //       message.error("领取后不能在更改");
    //       this.setState({
    //         uploading: false
    //       })
    //     }
    // });
  }

  render() {

    return (
      <div>
          {this.state.operable ?
          <Flex className="w1180 mt-20" align="start">
            <SiderMenu
              ref={"siderMenu"}
              setMenuList={this.setMenuList}
              title="自助报到"
              /*   active={0}*/
              mkbz={this.state.mkbz}
              menuType="自助报到"
              sfxs = "true"
            />
            <Flex.Item className="page_con_r">
              <Breadcrumb
                noLine
                list={[
                  { name: "首页", url: "/index" },
                  { name: "自助报到", url: "/register" },
                  { name: this.state.hjmc },
                ]}
              />
              <Spin spinning={this.state.uploading}>
                <div className="box">
                  <Hint />
                  <TitleTop
                      className="mt-20"
                      title={this.state.hjmc}
                      extra={false}
                  >   
                  </TitleTop>
                  <br/>
                  <div className="tip">
                    <RadioGroup onChange={this.onChange} value={this.state.radioValue}>
                      {
                        this.state.lbnrList.map(
                          (elem, index) => {
                            return (
                              <Row style={{marginTop: '20px'}}>
                                <Col
                                    key={index}
                                    span={4}
                                >
                                    <Radio
                                        value={
                                            elem.pkid
                                        }
                                    >
                                        <span>{elem.lbmc+'：'}</span>
                                        <span>{elem.lbnr}</span>
                                    </Radio>
                                </Col>
                              </Row>
                            )
                          }
                        )
                      }
                    </RadioGroup>
                  </div>
                  <div className="p-sw text-center mt-30">
                    <NextButton
                      nextUrl={this.state.nextUrl}
                      search={this.state.search}
                    />
                  </div>
                </div>
              </Spin>
            </Flex.Item>
          </Flex>
          :<CommonTip hjmc={"报到情况填写"} key={'GD004'} mkbz='GD004' nonOperationalData={this.state.nonOperationalData}/>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/pages/SelfHelp/carePackage/index.js